import React, { Children } from 'react';

export class Heading extends React.PureComponent {
    public render() {
        return (
            <div className="start-subcontent-heading">
                {this.props.children}
            </div>
        );
    }
}

